import React, { useEffect, useState } from 'react';
import '../CSS/Portfolio.css';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    document.title = 'Portfolio & Gallery | MuscleCrete';
    document.querySelector('meta[name="description"]').setAttribute(
      'content',
      'Browse our portfolio of successful projects showcasing MuscleCrete products in real-world applications.'
    );
  }, []);

  const portfolioItems = [
    {
      id: 1,
      title: 'Commercial Building Coating',
      category: 'commercial',
      image: 'https://via.placeholder.com/400x300?text=Commercial+Coating',
      description: 'High-performance concrete coating for commercial complex',
      beforeAfter: true
    },
    {
      id: 2,
      title: 'Residential Floor Installation',
      category: 'residential',
      image: 'https://via.placeholder.com/400x300?text=Residential+Floor',
      description: 'Durable tile adhesive installation in residential project',
      beforeAfter: false
    },
    {
      id: 3,
      title: 'Industrial Application',
      category: 'industrial',
      image: 'https://via.placeholder.com/400x300?text=Industrial',
      description: 'Heavy-duty coating for industrial facility',
      beforeAfter: true
    },
    {
      id: 4,
      title: 'Hotel Renovation',
      category: 'commercial',
      image: 'https://via.placeholder.com/400x300?text=Hotel+Renovation',
      description: 'Premium finish using MuscleCrete products',
      beforeAfter: false
    },
    {
      id: 5,
      title: 'Warehouse Flooring',
      category: 'industrial',
      image: 'https://via.placeholder.com/400x300?text=Warehouse',
      description: 'High-traffic warehouse floor treatment',
      beforeAfter: true
    },
    {
      id: 6,
      title: 'Residential Bathroom',
      category: 'residential',
      image: 'https://via.placeholder.com/400x300?text=Bathroom',
      description: 'Waterproof grout and tile adhesive application',
      beforeAfter: false
    },
    {
      id: 7,
      title: 'Mall Renovation',
      category: 'commercial',
      image: 'https://via.placeholder.com/400x300?text=Mall+Renovation',
      description: 'Large-scale mall refurbishment project',
      beforeAfter: true
    },
    {
      id: 8,
      title: 'Factory Floor',
      category: 'industrial',
      image: 'https://via.placeholder.com/400x300?text=Factory+Floor',
      description: 'Industrial-grade flooring solution',
      beforeAfter: false
    }
  ];

  const filteredItems = activeFilter === 'all'
    ? portfolioItems
    : portfolioItems.filter(item => item.category === activeFilter);

  const categories = [
    { value: 'all', label: 'All Projects' },
    { value: 'residential', label: 'Residential' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'industrial', label: 'Industrial' }
  ];

  return (
    <main className="portfolio-page">
      {/* Hero Section */}
      <section className="portfolio-hero">
        <div className="container">
          <h1>Our Portfolio</h1>
          <p>Explore successful MuscleCrete projects across residential, commercial, and industrial sectors</p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="portfolio-filters">
        <div className="container">
          <div className="filter-buttons">
            {categories.map(category => (
              <button
                key={category.value}
                className={`filter-btn ${activeFilter === category.value ? 'active' : ''}`}
                onClick={() => setActiveFilter(category.value)}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="portfolio-gallery">
        <div className="container">
          <div className="gallery-grid">
            {filteredItems.map(item => (
              <div
                key={item.id}
                className="gallery-item"
                onClick={() => setSelectedImage(item)}
              >
                <div className="gallery-image-wrapper">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="gallery-image"
                  />
                  <div className="gallery-overlay">
                    <div className="overlay-content">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                      {item.beforeAfter && <span className="before-after-badge">Before & After</span>}
                    </div>
                  </div>
                </div>
                <div className="gallery-info">
                  <h3>{item.title}</h3>
                  <p className="category-label">{item.category.charAt(0).toUpperCase() + item.category.slice(1)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button
              className="lightbox-close"
              onClick={() => setSelectedImage(null)}
              aria-label="Close lightbox"
            >
              ×
            </button>
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="lightbox-image"
            />
            <div className="lightbox-info">
              <h2>{selectedImage.title}</h2>
              <p>{selectedImage.description}</p>
              {selectedImage.beforeAfter && (
                <span className="before-after-badge">Before & After Project</span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="portfolio-cta">
        <div className="container">
          <h2>Interested in MuscleCrete for Your Project?</h2>
          <p>Contact us to discuss your specific requirements and find the perfect solution.</p>
          <a href="/contact" className="cta-button">Get a Quote</a>
        </div>
      </section>
    </main>
  );
};

export default Portfolio;
